export default (wizardFormRoute, state) =>
  wizardFormRoute.childRoutes
    .filter(
      route =>
        typeof route.wizardFormOrder === 'number' &&
        (!route.excludeFromWizard || !route.excludeFromWizard(state)),
    )
    .sort((a, b) => a.wizardFormOrder - b.wizardFormOrder);
